export const BottomArrow = () => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1L7 7L1 0.999999"
        stroke="#666666"
        strokeWidth="1.33"
        strokeLinecap="round"
      />
    </svg>
  );
};
